var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"mdc-top-app-bar vt-top-app-bar",class:{
  'mdc-top-app-bar--short':_vm.short,
  'mdc-top-app-bar--short-collapsed':_vm.shortCollapsed,
  'mdc-top-app-bar--fixed':_vm.fixed,
  'mdc-top-app-bar--prominent':_vm.prominent,
  'mdc-top-app-bar--dense':_vm.dense,
  'vt-top-app-bar--animating':_vm.animating_,
},style:({
  transform:'translateY('+_vm.top_+'px)',
})},[_c('div',{ref:"topAppBarRow",staticClass:"mdc-top-app-bar__row"},[_vm._t("default"),_c('mdc-top-app-bar-section',{attrs:{"align-start":""}},[_c('mdc-top-app-bar-action-item',{nativeOn:{"click":function($event){return _vm.emitClickLeftAction_()}}},[_vm._v(_vm._s(_vm.leftActionIcon))]),_c('mdc-top-app-bar-title',[_vm._t("title")],2)],1),_c('mdc-top-app-bar-section',{attrs:{"align-end":"","role":"toolbar"}},[_vm._t("aling-end")],2)],2),(_vm.$slots['tab-bar'] !== undefined)?_c('div',{staticClass:"vt-top-app-bar__tab-bar"},[_vm._t("tab-bar")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }